import React from 'react';
import colors from '../../utils/colors';
import { Badge } from '../ui-kit';

const StyledAvailabilityRequirement = props => {
  const H = props =>
    props.size === 'large' ? (
      <h4 className={props.className}>{props.children}</h4>
    ) : (
      <h5 className={props.className}>{props.children}</h5>
    );
  return (
    <H size={props.size} className="mt-1 me-1 fw-semibold">
      <Badge color={props.color}>{props.children}</Badge>
    </H>
  );
};

const StyledAvailabilityRequirementLevel = StyledAvailabilityRequirement;

const AvailabilityRequirementLevel = ({ serviceLevel, availabilityRequirementLevel }) => {
  if (serviceLevel !== 'in_service') return null;
  if (!availabilityRequirementLevel) return null;
  const { name, short_code } = availabilityRequirementLevel;

  return (
    <StyledAvailabilityRequirementLevel color={availabilityRequirementLevel.html_color}>
      {short_code || name}
    </StyledAvailabilityRequirementLevel>
  );
};

const TaskAvailabilityCodes = ({ serviceLevel, taskAvailabilityCodes }) => {
  if (serviceLevel !== 'in_service') return null;

  const availabilityCodes = Object.values(taskAvailabilityCodes)
    .map(({ availabilityCode }) => availabilityCode)
    .filter(Boolean);

  return (
    <React.Fragment>
      {availabilityCodes.map(availabilityCode => (
        <StyledAvailabilityRequirementLevel key={availabilityCode.id} color={availabilityCode.html_color}>
          {availabilityCode.short_code}
        </StyledAvailabilityRequirementLevel>
      ))}
    </React.Fragment>
  );
};

const ScheduleWarning = props => {
  if (!props.availabilityRequirement) return null;
  if (!props.availabilityRequirementState) return null;

  const { name, short_code } = props.availabilityRequirement;

  const { serviceLevel, warningLevel, availabilityRequirementLevel, taskAvailabilityCodes } =
    props.availabilityRequirementState;

  const combinedState = serviceLevel === 'in_service' ? warningLevel : serviceLevel;

  return (
    <div className="d-inline-flex overflow-hidden">
      <StyledAvailabilityRequirement size={props.size} color={colors[combinedState]}>
        {short_code || name}
      </StyledAvailabilityRequirement>
      <AvailabilityRequirementLevel
        serviceLevel={serviceLevel}
        availabilityRequirementLevel={availabilityRequirementLevel}
      />
      <TaskAvailabilityCodes serviceLevel={serviceLevel} taskAvailabilityCodes={taskAvailabilityCodes} />
    </div>
  );
};

export default ScheduleWarning;
